var map = {
	"./australia.png": 55658,
	"./belgium.png": 55267,
	"./brazil.png": 71800,
	"./canada.png": 84088,
	"./china.png": 15693,
	"./france.png": 28747,
	"./germany.png": 95055,
	"./india.png": 95565,
	"./italy.png": 8657,
	"./japan.png": 18172,
	"./netherlands.png": 92052,
	"./poland.png": 64482,
	"./portugal.png": 12656,
	"./russia.png": 55313,
	"./spain.png": 35235,
	"./sweden.png": 83214,
	"./united-kingdom.png": 62507,
	"./united-states.png": 80720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;